<template>
  <v-dialog v-model="dialog" max-width="400" @click:outside="close">
    <v-card>
      <v-card-title class="headline">Place A Bet</v-card-title>
      <v-card-text>
        <v-tabs v-model="tab" height="30" color="black">
          <v-tab v-for="m in markets()" :key="m">
            {{ formatMarketType(m) }}
          </v-tab>
        </v-tabs>

        <v-form v-model="valid">
          <v-tabs-items v-model="tab">
            <v-tab-item v-for="m in markets()" :key="m">
              <v-radio-group
                v-model="selectedRunner"
                required
                :rules="[rules.required]"
              >
                <v-row v-for="s in raceSelections(m)" :key="s.id">
                  <v-col cols="8">
                    <v-radio :key="s.id" :label="displayName(s)" :value="s">
                    </v-radio>
                  </v-col>
                  <v-col cols="2">
                    <span class="price back-price">
                      {{ bookiePrice(m, s) }}
                    </span>
                  </v-col>
                  <v-col cols="2">
                    <span class="price lay-price">
                      {{ betfairPrice(m, s) }}
                    </span>
                  </v-col>
                </v-row>
              </v-radio-group>
            </v-tab-item>
          </v-tabs-items>

          <v-text-field
            label="Stake"
            v-model="stake"
            :rules="[rules.required, rules.number, rules.positive]"
          />
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="red darken-1" text @click="close">
          Cancel
        </v-btn>

        <v-btn color="green darken-1" :disabled="!valid" text @click="validate">
          Confirm
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { marketType } from "../lib/formatting";
export default {
  name: "PlaceBet",
  data() {
    return {
      tab: null,
      valid: false,
      selectedRunner: null,
      stake: 1,
      rules: {
        required: v => !!v || "Required",
        number: v => /^\d*\.?\d*$/.test(v) || "Invalid stake",
        positive: v => parseFloat(v) > 0 || "Invalid stake"
      }
    };
  },
  props: ["bot", "race", "dialog", "close", "confirm"],
  computed: {},
  methods: {
    markets() {
      return Object.keys(this.race.markets);
    },
    raceSelections(type) {
      const selections = this.$store.getters.selectionsByRaceID(
        this.race.bot,
        this.race.id
      );
      return selections.filter(s => s.marketType === type);
    },
    validate() {
      this.confirm(this.race, this.selectedRunner, parseFloat(this.stake));
    },
    displayName(selection) {
      if (selection.number === 200) return selection.name;

      return `${selection.number}. ${selection.name}`;
    },
    bookiePrice(marketType, selection) {
      const p = this.$store.getters.getBookiePrice(
        this.race.bot,
        this.race.id,
        selection.number,
        marketType
      );

      return p || 0;
    },
    betfairPrice(marketType, selection) {
      const p = this.$store.getters.getBetfairPrices(
        this.race.bot,
        marketType === "FIXED_WIN"
          ? this.race.betfairWinID
          : this.race.betfairPlaceID,
        selection.betfairID,
        "lay"
      );
      if (!p) return 0;
      return p[0][0];
    },
    formatMarketType: marketType
  }
};
</script>

<style lang="scss" scoped>
.price {
  float: right;
}

.back-price {
  color: royalblue;
}

.lay-price {
  color: palevioletred;
}
</style>
